<template>
  <div :class="['price_box', size, { selected: isSelected }]">
    <p class="name">{{ name }}</p>
    <p class="prices">
      <span class="discount_price">
        <span class="sign">￥</span>
        {{ discountPrice }}
      </span>
      <span class="price">
        <span class="sign">￥</span>
        {{ price }}
      </span>
    </p>
    <p v-if="tipMiddle" class="tip_middle">
      <span class="text">{{ tipMiddle }}</span>
    </p>
    <p v-if="isShowTipsFooter" :class="['tips_footer', { mg: size === boxSize.small && tipsFooterWithLine.length === 3, pd40: size === boxSize.big && tipsFooterWithLine.length === 3 } ]">
      <span v-for="(item, index) in tipsFooterWithLine" :key="index" class="tip">
        {{ item }}
      </span>
    </p>
    <em class="corner_right" />
    <em class="hook" />
    <div v-if="isShowLeftCount && leftCountPackageForever" class="pendant">
      <div class="text">剩余名额: {{ leftCountPackageForever }}</div>
      <i class="triangle" />
    </div>
    <div v-show="isShowCountDown" class="pendant">
      <div class="text">倒计时: {{ textCountDown }}</div>
      <i class="triangle" />
    </div>
  </div>
</template>

<script>
import api from '@/api'

const boxSize = {
  big: 'size_big',
  small: 'size_small',
}

export default {
  name: 'PriceBox',

  props: {
    name: {
      type: String,
      default: ''
    },

    price: {
      type: Number,
      default: 0
    },

    discountPrice: {
      type: [String, Number],
      default: ''
    },

    tipMiddle: {
      type: String,
      default: ''
    },

    tipsFooter: {
      type: Array,
      default: () => []
    },

    isSelected: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: boxSize.big
    },

    isShowCountDown: {
      type: Boolean,
      default: false
    },

    isShowLeftCount: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      boxSize,
      timeDiff: 0,
      textCountDown: '',
      interval: null
    }
  },

  computed: {
    isShowTipsFooter () {
      return this.tipsFooter.length > 0
    },
    tipsFooterWithLine () {
      const result = []
      this.tipsFooter.forEach((tip, index) => {
        result.push(tip)
        if (index !== this.tipsFooter.length - 1) {
          result.push('|')
        }
      })
      return result
    },
    leftCountPackageForever () {
      return this.$store.state.buyDialog.leftCountPackageForever
    },
  },

  mounted () {
    this.initInterval()
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    async initInterval () {
      const now = await this.getServiceTime()
      const todayEnd = new Date(now).setHours(23, 59, 59, 999)
      this.timeDiff = todayEnd - now
      this.updateTextCountDown(this.timeDiff)
      this.interval = setInterval(() => {
        this.timeDiff -= 1000
        if (this.timeDiff < 0) {
          this.timeDiff = 24 * 60 * 60 * 1000 + this.timeDiff
        }
        this.updateTextCountDown(this.timeDiff)
      }, 1000)
    },

    getServiceTime () {
      return api.common.getServiceTime().then(res => res?.data?.timestamp * 1000)
    },

    updateTextCountDown (timeDiff) {
      const date = timeDiff
      const hours = parseInt(date / (1000 * 60 * 60))
      const minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = parseInt((date % (1000 * 60)) / 1000)
      const strHours = hours < 10 ? ('0' + hours) : hours
      const strMinutes = minutes < 10 ? ('0' + minutes) : minutes
      const strSeconds = seconds < 10 ? ('0' + seconds) : seconds
      this.textCountDown = `${strHours}:${strMinutes}:${strSeconds}`
    }
  },
}
</script>

<style lang="scss" scoped>
.price_box { position: relative; box-sizing: border-box; display: flex; flex-direction: column; align-items: center; height: 143px; background: #FFFBE9; border: 1px solid #CB8000; border-radius: 8px;
  &.size_big { width: 456px; }
  &.size_small { width: 168px; }
}
.price_box.selected { background: linear-gradient(90deg, #FFF5E8, #FFCC81);
  .name { font-weight: 600; }
  .corner_right { position: absolute; top: 0; right: 0; width: 40px; height: 40px; background-image: url("~@/assets/images/icon_corner_right.png"); }
  .hook { position: absolute; top: 5px; right: 5px; width: 15px; height: 13px; background-image: url("~@/assets/images/icon_hook.png"); }
}
.name { width: auto; margin: 14px auto 0 auto; font-size: 18px; font-weight: 400; color: #553E1C; }
.prices { width: auto; height: 31px; margin: 5px auto 0 auto;
  .discount_price { font-size: 30px; font-weight: bold; color: #553E1C;
    .sign { font-size: 14px; }
  }
  .price { font-size: 14px; font-weight: 400; color: #553E1C; text-decoration: line-through; }
}
.tip_middle { display: flex; align-items: center; justify-content: center; width: fit-content; height: 19px; margin: 12px auto 0 auto; border: 1px solid #553E1C; border-radius: 10px;
  .text { margin: 0 17px; font-size: 12px; font-weight: 400; color: #553E1C; }
}
.tips_footer { position: absolute; bottom: 0; left: 0; display: flex; align-items: center; justify-content: space-around; width: 100%; height: 24px; font-size: 12px; font-weight: 400; color: #553E1C; background: #FFE8C0; border-top: 1px solid #CB8000; border-radius: 0px 0px 8px 8px;
  &.mg { box-sizing: border-box; padding: 0 10px; }
  &.pd40 { box-sizing: border-box; padding: 0 40px; }
}
.pendant { position: absolute; top: -9px; left: -5px; font-size: 12px; color: #fff;
  .text { width: 102px; height: 18px; text-align: center; background: linear-gradient(90deg, #FA762E, #FF2121); border-radius: 4px 4px 4px 0px; }
  .triangle { position: absolute; width: 0; height: 0; border: 2.5px solid #B21D17; border-bottom-color: transparent; border-left-color: transparent; }
}

</style>
